import { Layout, Field, Title } from "@introist/react-foundation/v2";
import { TextInput } from "components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";
import { useMemo } from "react";

export const WorkableConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const creds = useMemo(() => {
    return (
      (values?.credentials as { apiKey: string; domain?: string }) ?? {
        apiKey: "",
        domain: ""
      }
    );
  }, [values?.credentials]);

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="Domain">
        <TextInput
          placeholder="Your workable subdomain"
          value={creds.domain}
          onChange={domain =>
            onChange({
              credentials: { ...creds, domain }
            })
          }
          endAdornment={<Title>.workable.com</Title>}
        />
      </Field>
      <Field title="Api key">
        <TextInput
          placeholder="Api key"
          value={creds.apiKey}
          type="password"
          onChange={apiKey =>
            onChange({
              credentials: { ...creds, apiKey }
            })
          }
        />
      </Field>
    </Layout.Group>
  );
};
